import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import { baseurl } from "../../Baseurl"; 
import SellerNavbar from "../../component/SellerNavbar";
import SellerSidebar from "../../component/SellerSidebar"; 
import Swal from "sweetalert2"; // Import SweetAlert2 for notifications
 
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import Select from "react-select";
import AdminTopbar from "../../component/AdminComp/AdminTopbar";

const AdminEditListings = () => {
  const { listing_id } = useParams();
  const navigate = useNavigate();
 
  // console.log("Listing ID from URL:", listing_id);

  const [formData, setFormData] = useState({
    title: "",
    description: "",
    listingCondition: "",
    listingCategory: "",
    listingBrand: "",
    listingType: "",
    price: "",
    currency: "INR",
    quantity: "",
    unitquantity: "",
    upc: "",
    mpn: "",
    modal: "",
    manufacturer: "",
    unlimitedQuantity: false,
  });


  const [brands, setBrands] = useState([]);
  useEffect(() => {
    const fetchBrands = async () => {
      try {
        const response = await axios.get(`${baseurl}getAllBrands`);
        if (response.status === 200) {
          setBrands(response.data.data); // Assuming response contains a `data` array
        }
      } catch (error) {
        console.error("Error fetching brands:", error);
      }
    };

    fetchBrands();
  }, []);

  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(false);



  const [errors, setErrors] = useState({});
  // const [loading, setLoading] = useState(true);  

  useEffect(() => {
    // Fetch listing details by listing_id
    const fetchListingDetails = async () => {
      try {
        const response = await axios.get(`${baseurl}seller/listing/${listing_id}`);
        const data = response.data.listingData;  // Notice the updated access to listingData
        // console.log("response", response);

        if (data) {
          setFormData({
            title: data.title || "", 
            description: data.description || "",
            listingCondition: data.condition || "", 
            listingCategory: data.category || "", 
            listingBrand: data.brand || "", 
            listingType: data.type || "", 
            price: data.price || "",
            currency: data.currency || "INR",
            quantity: data.quantity || "",
            unitquantity: data.unitquantity || "",
            upc: data.upc || "",
            mpn: data.mpn || "",
            modal: data.modal || "",
            manufacturer: data.manufacturer || "",
            unlimitedQuantity: data.unlimitedquantity || false,
          });
        }
      } catch (error) {
        console.error("Error fetching listing details:", error);
      } finally {
        setLoading(false);  // Set loading to false once data is fetched
      }
    };
  
    fetchListingDetails();
  }, [listing_id]);


  
 

  useEffect(() => {
    const fetchCategories = async () => {
      setLoading(true);
      try {
        const response = await axios.get(`${baseurl}getMenusByCategory`);
        if (response.data) {
          const categoryOptions = response.data.map((category) => ({
            value: category.id, 
            label: category.path, // Path or name of the category
          }));
          setCategories(categoryOptions);
        }
      } catch (error) {
        console.error("Error fetching categories:", error);
      } finally {
        setLoading(false);
      }
    };
  
    fetchCategories();
  }, []);
  
  const handleCategoryChange = (e) => {
    const selectedValue = e.target.value;
    setFormData((prevData) => ({
      ...prevData,
      listingCategory: selectedValue,  // Update selected category
    }));
  };
  
  
  

  const handleDescriptionChange = (content) => {
    setFormData({ ...formData, description: content });
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleCheckboxChange = (e) => {
    const { name, checked } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: checked,
      ...(name === "unlimitedQuantity" && checked ? { quantity: "" } : {}),
    }));
  };

  const validateForm = () => {
    let formErrors = {};
    if (!formData.title.trim()) formErrors.title = "Title is required.";
    if (!formData.description.trim())
      formErrors.description = "Description is required.";
    if (!formData.listingCondition)
      formErrors.listingCondition = "Listing condition is required.";
    // if (!formData.listingCategory)
    //   formErrors.listingCategory = "Listing category is required.";
    if (!formData.listingType)
      formErrors.listingType = "Listing type is required.";
    if (!formData.price) formErrors.price = "Price is required.";
    if (!formData.unlimitedQuantity && !formData.quantity)
      formErrors.quantity = "Quantity is required.";
    setErrors(formErrors);
    return Object.keys(formErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
  
    // console.log("Form data before validation:", formData);
  
    if (validateForm()) {
      // Prepare the data for submission
      const sellerId = localStorage.getItem("seller_id");
      const requestData = {
        seller_id: sellerId,
        title: formData.title,
        description: formData.description,
        listingCondition: formData.listingCondition,
        listingCategory: formData.listingCategory,
        listingBrand: formData.listingBrand,
        listingType: formData.listingType,
        price: formData.price,
        currency: formData.currency,
        quantity: formData.quantity,
        unlimitedQuantity: formData.unlimitedQuantity,
        listing_id: listing_id,
        unitquantity: formData.unitquantity,
        upc: formData.upc,
        mpn: formData.mpn,
        modal: formData.modal,
        manufacturer: formData.manufacturer
      }; 

      // Log the data to see what's being sent
      // console.log("Form data being sent:", requestData);

      try {
        setLoading(true);  // Start loading

        const response = await axios.put(`${baseurl}update_listing`, requestData, {
          headers: {
            "Content-Type": "application/json", // Use JSON content type
          },
        });
  
        // console.log("Form submitted successfully:", response.data);

        // Show SweetAlert2 on success
        Swal.fire({
          icon: 'success',
          title: 'Listing Updated!',
          text: 'Your listing has been updated successfully.',
        });

        // Navigate or redirect as needed after successful update
        const { listing_unique_id } = response.data.data;
        if (listing_unique_id) {
          navigate(`/seller/listing/${listing_unique_id}`);  // You can adjust this URL as needed
        }
      } catch (error) {
        console.error("Error submitting form:", error);
      } finally {
        setLoading(false);  // Stop loading
      }
  
      setErrors({});
    } else {
      console.log("Form validation failed", errors); // Log validation errors if any
    }
  };

  if (loading) {
    // Show the loader while data is being fetched
    return (
      <div className="loader-container">
        <div className="loader"></div> {/* Your custom loader CSS */}
      </div>
    );
  }




  return (
    <>
 
      <div>

        <AdminTopbar/>
        <section className="mb-5">
          <div className="container-fluid">
            <div className="row my-3 g-2 justify-content-center">
             
              

              <div className="col-md-112">
 

                <div className="reviewcls text-start">
                  <h4 className="selh1">Update Listing : <strong className="">{formData.title}</strong></h4>
                  <hr />

                  

                  {/* Show loader while `loading` is true */}
          {loading && (
            <div className=" ">
              <span class="loader"></span>  
            </div>
          )}


                  <form className="contact-form text-start" onSubmit={handleSubmit}>
                    <div className="row g-2">
                      <div className="col-md-12">
                        <label htmlFor="title" className="form-label">
                          Title<span className="text-danger">*</span>
                        </label>
                        <input
                          type="text"
                          id="title"
                          name="title"
                          className="form-control"
                          placeholder="Enter your listing title"
                          value={formData.title}
                          onChange={handleInputChange}
                          required
                        />
                        {errors.title && (
                          <small className="text-danger">{errors.title}</small>
                        )}
                      </div>

                      <div className="col-md-6">
                        <label htmlFor="listingCondition" className="form-label">
                          Listing Condition<span className="text-danger">*</span>
                        </label>
                        <select
                          id="listingCondition"
                          name="listingCondition"
                          className="form-control"
                          value={formData.listingCondition}
                          onChange={handleInputChange}
                          required
                        >
                          <option value="">Select a condition</option>
                          <option value="used">Used</option>
                          <option value="new">New</option>
                          <option value="refurbished">Refurbished</option>
                          <option value="forParts">For Parts/Not Working</option>
                          <option value="notSpecified">Not Specified</option>
                        </select>
                        {errors.listingCondition && (
                          <small className="text-danger">{errors.listingCondition}</small>
                        )}
                      </div>



                      <div className="col-md-6">
      <label htmlFor="listingBrand" className="form-label">
        Listing Brand
      </label>
      <select
        id="listingBrand"
        name="listingBrand"
        className="form-control"
        value={formData.listingBrand}
        onChange={(e) =>
          setFormData({ ...formData, listingBrand: e.target.value })
        }
      >
        <option value="">Select a Brand</option>
        {brands.map((brand) => (
          <option key={brand.id} value={brand.id}>
            {brand.brand_name}
          </option>
        ))}
      </select>
      {errors.listingBrand && (
        <small className="text-danger">{errors.listingBrand}</small>
      )}
    </div>


                      

    <div className="col-md-12">
  <label htmlFor="listingCategory" className="form-label">
    Listing Category<span className="text-danger">*</span>
  </label>

  <select
  id="listingCategory"
  name="listingCategory"
  className="form-select"
  value={formData.listingCategory || ""}  // Ensure it's a valid value or empty string
  onChange={handleCategoryChange}  // Handle category change to update formData
  disabled={loading}  // Disable while loading
>
  <option value="" disabled>
    Select categories
  </option>
  {categories.map((category) => (
    <option key={category.value} value={category.value}>
      {category.label}
    </option>
  ))}
</select>

{/* {errors.listingBrand && (
        <small className="text-danger">{errors.listingCategory}</small>
      )} */}
 
  
</div>




<div className="col-md-4">
                        <label htmlFor="upc" className="form-label">
                          UPC
                        </label>
                        <input
                          type="text"
                          id="upc"
                          name="upc"
                          className="form-control"
                          placeholder="Enter UPC"
                          value={formData.upc}
                          onChange={handleInputChange} 
                        /> 
                      </div>


                      <div className="col-md-4">
                        <label htmlFor="mpn" className="form-label">
                          MPN
                        </label>
                        <input
                          type="text"
                          id="mpn"
                          name="mpn"
                          className="form-control"
                          placeholder="Enter MPN"
                          value={formData.mpn}
                          onChange={handleInputChange} 
                        /> 
                      </div>

                      <div className="col-md-4">
                        <label htmlFor="modal" className="form-label">
                          Modal
                        </label>
                        <input
                          type="text"
                          id="modal"
                          name="modal"
                          className="form-control"
                          placeholder="Enter Modal"
                          value={formData.modal}
                          onChange={handleInputChange} 
                        /> 
                      </div>

                      <div className="col-md-12">
                        <label htmlFor="manufacturer" className="form-label">
                          Country/ Region Of Manufacturing
                        </label>
                        <input
                          type="text"
                          id="manufacturer"
                          name="manufacturer"
                          className="form-control"
                          placeholder="Enter Country/ Region Of Manufacturing"
                          value={formData.manufacturer}
                          onChange={handleInputChange} 
                        /> 
                      </div>



                      <div className="col-md-12">
                        <label className="form-label">
                          Listing Type<span className="text-danger">*</span>
                        </label>
                        <div className="form-check">
                          <input
                            className="form-check-input"
                            type="radio"
                            name="listingType"
                            id="quoteRequest"
                            value="quoteRequest"
                            onChange={handleInputChange}
                            checked={formData.listingType === "quoteRequest"}
                          />
                          <label className="form-check-label" htmlFor="quoteRequest">
                            <strong>Request a Quote</strong>
                          </label>
                        </div>
                        <div className="form-check">
                          <input
                            className="form-check-input"
                            type="radio"
                            name="listingType"
                            id="directSell"
                            value="directSell"
                            onChange={handleInputChange}
                            checked={formData.listingType === "directSell"}
                          />
                          <label className="form-check-label" htmlFor="directSell">
                            <strong>Sell Directly</strong>
                          </label>
                        </div>
                        {errors.listingType && (
                          <small className="text-danger">{errors.listingType}</small>
                        )}
                      </div>

                      <div className="col-md-4">
                        <label htmlFor="price" className="form-label">
                          Price<span className="text-danger">*</span>
                        </label>
                        <input
                          type="text"
                          id="price"
                          name="price"
                          className="form-control"
                          placeholder="Enter your listing price"
                          value={formData.price}
                          onChange={handleInputChange}
                          required
                        />
                        {errors.price && (
                          <small className="text-danger">{errors.price}</small>
                        )}
                      </div>

                      <div className="col-md-4">
                        <label htmlFor="quantity" className="form-label">
                          Quantity
                        </label>
                        <input
                          type="text"
                          id="quantity"
                          name="quantity"
                          className="form-control"
                          placeholder="Enter quantity"
                          value={formData.quantity}
                          onChange={handleInputChange}
                          disabled={formData.unlimitedQuantity}
                        />
                        {errors.quantity && (
                          <small className="text-danger">{errors.quantity}</small>
                        )}
                      </div>


                      <div className="col-md-4">
                        <label htmlFor="unitquantity" className="form-label">
                          Unit Quantity 
                        </label>
                        <input
                          type="text"
                          id="unitquantity"
                          name="unitquantity"
                          className="form-control"
                          placeholder="Enter Unit Quantity"
                          value={formData.unitquantity}
                          onChange={handleInputChange} 
                        /> 
                      </div>

                      <div className="col-md-12">
                        <div className="form-check">
                          <input
                            className="form-check-input"
                            type="checkbox"
                            id="unlimitedQuantity"
                            name="unlimitedQuantity"
                            checked={formData.unlimitedQuantity}
                            onChange={handleCheckboxChange}
                          />
                          <label className="form-check-label" htmlFor="unlimitedQuantity">
                            Unlimited Quantity
                          </label>
                        </div>
                      </div>

                      <div className="col-md-12">
      <label htmlFor="description" className="form-label">
        Description<span className="text-danger">*</span>
      </label>
      <ReactQuill
  value={formData.description}
  onChange={handleDescriptionChange}
  modules={{
    toolbar: [
      ["bold", "italic", "underline", "strike",], // Basic text styles
      [{ align: [] }], // Text alignment (left, center, right)
      [{ list: "ordered" }, { list: "bullet" }], // Lists (ordered, bullet)
      ["link"], // Hyperlink insertion
      [
        { header: "1" },
        { header: "2" }, 
        { font: [] }, // Font options
         
      ],
      [{ color: [] }, { background: [] }], // Text color and background color
      ["blockquote"], // Blockquote for quoted text
      ["code-block"], // Code block option
      ["undo", "redo"], // Undo and redo actions
    ],
  }}
  className="quill-editor" // Added class for custom styling
/>

      {errors.description && (
        <small className="text-danger">{errors.description}</small>
      )}
    </div>

                      <div className="col-md-12 text-center">
                        <button type="submit" className="btn btn-primary">
                          Update Listing
                        </button>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default AdminEditListings;
